import React, { useState } from 'react';
import './Navbar.css';
import logo from "../../assets/logo_thothit.png";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  NavLink,
  NavbarBrand
} from 'reactstrap';

const NavBar = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="container">
      <Navbar className="navStyle" expand="md">
        <NavbarBrand href="/">
          <img src={logo} alt="thothLogo" width="150px" className="mr-5"/>
        </NavbarBrand>
        <NavbarToggler className="togglerMenu" onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem>
              <NavLink className="navlinkColor" href="/">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="navlinkColor" href="/services">Services</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="navlinkColor" href="/about">About</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="navlinkColor" href="/posts">Posts</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="navlinkColor" href="/contact">Contact</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="navlinkColor" href="/careers">Careers</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default NavBar;
